export const refillTypesList = {
  1: {
    name: 'Provider',
    value: 1,
  },
  2: {
    name: 'Paid order (Refiller)',
    value: 2,
  },
  3: {
    name: 'Manual',
    value: 3,
  },
};
